// Detekce nativní aplikace (Capacitor WebView v apps/mobile). Na webu a ve Vitestu je vše "web":
// Capacitor bez nativního mostu vrací platformu web a nic z nativních pluginů se nespustí.
import { Capacitor } from '@capacitor/core'

export type NativePlatform = 'ios' | 'android' | 'web'

/** Běží aplikace v nativním obalu (iOS nebo Android), ne v prohlížeči nebo PWA. */
export function isNative(): boolean {
  try {
    return Capacitor.isNativePlatform()
  } catch {
    return false
  }
}

export function nativePlatform(): NativePlatform {
  if (!isNative()) return 'web'
  try {
    const platform = Capacitor.getPlatform()
    return platform === 'ios' || platform === 'android' ? platform : 'web'
  } catch {
    return 'web'
  }
}
